export const PATHS = {
  ROOT: 'applied-resumes',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
};
